import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Tooltip from "@material-ui/core/Tooltip";
// core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import Terminal from "components/Terminal/Terminal.jsx";

import customTabsStyle from "assets/jss/material-dashboard-react/components/customTabsStyle.jsx";

import httpr from "lib/httpRequest";
import { BASE_URL, isLocal } from "lib/config";
import ReactLoading from "react-loading";
import { AuthConsumer } from "react-check-auth";

class DashboardTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      subValue: 0,
      locations: [],
      isLoading: true,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    // get locations from chosen org
    if (this.props.tabs.length > 0) {
      if (this.props.tabs.length !== prevProps.tabs.length) {
        // initial location load
        this.getLocations();
      } else if (this.state.value !== prevState.value) {
        this.setState({ isLoading: !this.state.isLoading });
        this.getLocations();
      }
    }
  }

  getLocations() {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);
    return new Promise(async (resolve, reject) => {
      fetch
        .get(`${BASE_URL}${this.props.tabs[this.state.value].dataUrl}`)
        .then((response) => {
          this.setState({ locations: response.data, isLoading: false });
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  // Helper function to get license status for a location
  getLocationLicenseStatus(locationId, locationLicenses) {
    if (!locationLicenses || !Array.isArray(locationLicenses)) {
      return null;
    }
    
    const locationLicense = locationLicenses.find(
      loc => loc.locationId === locationId
    );
    
    return locationLicense ? locationLicense.license : null;
  }

  // Helper function to check if location is expired
  isLocationExpired(locationId, locationLicenses) {
    const license = this.getLocationLicenseStatus(locationId, locationLicenses);
    const isExpired = license && license.isValid === 0;
    return isExpired;
  }

  // Helper function to get days until expiration
  getDaysUntilExpiration(locationId, locationLicenses) {
    const license = this.getLocationLicenseStatus(locationId, locationLicenses);
    return license ? license.daysUntilExpiration : null;
  }

  // Helper function to check if location is expiring soon (within 30 days)
  isLocationExpiringSoon(locationId, locationLicenses) {
    const license = this.getLocationLicenseStatus(locationId, locationLicenses);
    const isExpiringSoon = license && 
           license.isValid === 1 && 
           license.daysUntilExpiration !== null &&
           license.daysUntilExpiration <= 30 &&
           license.daysUntilExpiration > 0;
    
    return isExpiringSoon;
  }

  handleChange = (event, value) => {
    this.setState({
      value,
      subValue: 0,
    });
  };

  handleSubTabChange = (event, value) => {
    this.setState({
      subValue: value,
    });
  };

  getKey() {
    return Math.floor(Math.random() * 100);
  }

  render() {
    const {
      canSubTabs,
      classes,
      headerColor,
      plainTabs,
      tabs,
      title,
      subtitle,
      rtlActive,
    } = this.props;

    const cardTitle = classNames({
      [classes.cardTitle]: true,
      [classes.cardTitleRTL]: rtlActive,
    });

    return (
      <AuthConsumer>
        {({ userInfo }) => {
          const allLocationLicenses = (userInfo && userInfo.member && userInfo.member.LocationLicenses) || [];
          
          // Filter license data to only include locations from the current organization
          const currentOrgId = this.props.tabs[this.state.value] && this.props.tabs[this.state.value].organizationId;
          const locationLicenses = allLocationLicenses.filter(
            loc => loc.organizationId === currentOrgId
          );
          
          return this.renderTabs(locationLicenses);
        }}
      </AuthConsumer>
    );
  }

  renderTabs(locationLicenses) {
    const {
      canSubTabs,
      classes,
      headerColor,
      plainTabs,
      tabs,
      title,
      subtitle,
      rtlActive,
    } = this.props;

    const cardTitle = classNames({
      [classes.cardTitle]: true,
      [classes.cardTitleRTL]: rtlActive,
    });

    // Build classes object for Tabs components, ensuring indicator is only included if it's a valid string
    const tabsClasses = {
      root: classes.tabsRoot,
    };
    if (classes.displayNone && typeof classes.displayNone === 'string') {
      tabsClasses.indicator = classes.displayNone;
    }

    if (canSubTabs) {
      let dataUrl = [];
      tabs.forEach((prop, key) => {
        dataUrl.push(prop.dataUrl);
      });

      const mainTabs = tabs.map((prop, key) => {
        var icon = {};
        if (prop.tabIcon) {
          icon = {
            icon: <prop.tabIcon />,
          };
        }
        return (
          <Tab
            classes={{
              root: classes.tabRootButton,
              labelContainer: classes.tabLabelContainer,
              label: classes.tabLabel,
              selected: classes.tabSelected,
              wrapper: classes.tabWrapper,
            }}
            key={key}
            label={prop.tabName.replace(/_/g, " ")}
            {...icon}
          />
        );
      });

      return (
        <div key={this.getKey()}>
          {tabs.map((prop, key) => {
            if (key === this.state.value) {
              if (this.state.isLoading) {
                return (
                  <Card plain={plainTabs} key={key}>
                    <CardHeader color={headerColor} plain={plainTabs}>
                      {title !== undefined ? (
                        <div className={cardTitle}>{title}</div>
                      ) : null}

                      <Tabs
                        key={`MainTab${key}`}
                        value={this.state.value}
                        onChange={this.handleChange}
                        classes={tabsClasses}
                        scrollable
                        scrollButtons="auto"
                        variant="scrollable"
                      >
                        {mainTabs}
                      </Tabs>
                    </CardHeader>
                    <CardBody>
                      <ReactLoading
                        type="spin"
                        color="#000000"
                        style={{
                          width: "20%",
                          margin: "auto",
                        }}
                      />
                    </CardBody>
                  </Card>
                );
              } else {
                return (
                  <Card plain={plainTabs} key={key}>
                    <CardHeader color={headerColor} plain={plainTabs}>
                      {title !== undefined ? (
                        <div className={cardTitle}>{title}</div>
                      ) : null}

                      <Tabs
                        key={`MainTab${key}`}
                        value={this.state.value}
                        onChange={this.handleChange}
                        classes={tabsClasses}
                        scrollable
                        scrollButtons="auto"
                        variant="scrollable"
                      >
                        {mainTabs}
                      </Tabs>

                      <div className={cardTitle}>{subtitle}</div>
                      <Tabs
                        key={`SubTab${key}`}
                        value={this.state.subValue}
                        onChange={this.handleSubTabChange}
                        classes={tabsClasses}
                        scrollable
                        scrollButtons="auto"
                        variant="scrollable"
                      >
                        {this.state.locations.map((loc, key) => {
                          var icon = {};
                          const isExpired = this.isLocationExpired(loc.LocationId, locationLicenses);
                          const isExpiringSoon = this.isLocationExpiringSoon(loc.LocationId, locationLicenses);
                          const daysUntilExpiration = this.getDaysUntilExpiration(loc.LocationId, locationLicenses);
                          
                          // Create label with license status indicator
                          let label = loc.LocationName.replace(/_/g, " ");
                          if (isExpired) {
                            label = `🔒 ${label} (Expired)`;
                          } else if (isExpiringSoon) {
                            label = `⚠️ ${label} (${daysUntilExpiration} days)`;
                          }

                          const tabElement = (
                            <Tab
                              classes={{
                                root: classes.tabRootButton,
                                labelContainer: classes.tabLabelContainer,
                                label: classes.tabLabel,
                                selected: classes.subTabSelected,
                                wrapper: classes.tabWrapper,
                              }}
                              key={loc.LocationId}
                              label={label}
                              disabled={isExpired}
                              {...icon}
                            />
                          );

                          // Wrap with tooltip based on license status
                          if (isExpired) {
                            return (
                              <Tooltip 
                                key={loc.LocationId}
                                title={isLocal === "true" || isLocal === true 
                                  ? "License expired - Please click Renew License and follow the instructions to send a renewal token to our support team."
                                  : "License expired - Please contact our support team for renewal."}
                                placement="top"
                              >
                                <span>{tabElement}</span>
                              </Tooltip>
                            );
                          } else if (isExpiringSoon) {
                            // For expiring tabs, add tooltip info to the tab itself
                            const tabWithTooltip = (
                              <Tab
                                classes={{
                                  root: classes.tabRootButton,
                                  labelContainer: classes.tabLabelContainer,
                                  label: classes.tabLabel,
                                  selected: classes.subTabSelected,
                                  wrapper: classes.tabWrapper,
                                }}
                                key={loc.LocationId}
                                label={label}
                                title={isLocal === "true" || isLocal === true 
                                  ? `License renewal due in ${daysUntilExpiration} days - Please click Renew License and follow the instructions to send a renewal token to our support team.`
                                  : `License renewal due in ${daysUntilExpiration} days - Please contact our support team for renewal.`}
                                {...icon}
                              />
                            );
                            return tabWithTooltip;
                          }

                          return tabElement;
                        })}
                      </Tabs>
                    </CardHeader>
                    <CardBody>
                      {this.state.locations.map((loc, key) => {
                        const isSD = loc.LocationId === 1 ? true : false;
                        const isExpired = this.isLocationExpired(loc.LocationId, locationLicenses);
                        const isExpiringSoon = this.isLocationExpiringSoon(loc.LocationId, locationLicenses);
                        
                        if (key === this.state.subValue) {
                          if (isExpired) {
                            return (
                              <div key={key} style={{ 
                                padding: '20px', 
                                textAlign: 'center',
                                backgroundColor: '#ffebee',
                                border: '1px solid #f44336',
                                borderRadius: '4px',
                                margin: '20px'
                              }}>
                                <h3 style={{ color: '#d32f2f', margin: '0 0 10px 0' }}>
                                  🔒 License Expired
                                </h3>
                                <p style={{ color: '#666', margin: '0' }}>
                                  This location's license has expired. {isLocal === "true" || isLocal === true 
                                    ? "Please click Renew License and follow the instructions to send a renewal token to our support team."
                                    : "Please contact our support team for renewal."}
                                </p>
                              </div>
                            );
                          }
                          
                          return (
                            <Terminal
                              isSocalDemo={isSD}
                              key={key}
                              dataUrl={`/api/terminal/location/${
                                loc.LocationId
                              }`}
                              locationId={loc.LocationId}
                            />
                          );
                        }
                        return null;
                      })}
                    </CardBody>
                  </Card>
                );
              }
            }
          })}
        </div>
      );
    }
  }
}

DashboardTabs.propTypes = {
  classes: PropTypes.object.isRequired,
  headerColor: PropTypes.oneOf([
    "warning",
    "success",
    "scmain",
    "danger",
    "info",
    "primary",
  ]),
  title: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      tabName: PropTypes.string.isRequired,
      tabIcon: PropTypes.func,
      tabContent: PropTypes.node.isRequired,
    })
  ),
  rtlActive: PropTypes.bool,
  plainTabs: PropTypes.bool,
};

export default withStyles(customTabsStyle)(DashboardTabs);



// WEBPACK FOOTER //
// ./src/components/CustomTabs/DashboardTabs.jsx